import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarContent({ as: Component = 'div', className, children, ...rest }) {
    return (
        <Component className={cn('grow text-dark-blue max-w-[316px]', className)} {...rest}>
            {children}
        </Component>
    );
}

SnackbarContent.propTypes = {
    as: PropTypes.elementType,
    className: PropTypes.string,
    children: PropTypes.node,
};
